// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"d3507e74","498":"0fbbeec4","703":"81ca876e","787":"d6aca012"}[chunkId] + ".chunk.js";
};